import api from "./axios";

export async function getOrganisms() {
  const response = await api.get("/organisms");
  return response;
}

export async function getOrganism(organismId) {
  const response = await api.get(`/organisms/${organismId}`);
  return response;
}

export async function postOrganism(organism) {
  const response = await api.post("/organisms", organism);
  return response;
}

export async function deleteOrganism(organismId) {
  const response = await api.delete(`/organisms/${organismId}`);
  return response;
}

export async function putOrganism(organism, organismId) {
  const response = await api.put(`/organisms/${organismId}`, organism);
  return response;
}
